/**
 * Prompts and descriptions for codebase_search
 */

/**
 * Default tool name for the warp grep tool
 */
export const WARP_GREP_TOOL_NAME = 'codebase_search';

/**
 * Default tool description for the warp grep tool
 */
export const WARP_GREP_DESCRIPTION = 
  'Very fast code search exploration subagent (not a grep tool) that runs parallel grep and file read calls over multiple turns to locate relevant files and line ranges. ' +
  'The search term should be a targeted natural-language query describing what you are trying to find or accomplish, e.g. ' +
  '"Find where authentication requests are handled in the Express routes" or "How do callers of processOrder handle the error case?". ' +
  'Fill in extra context you can infer to make the query specific. Do not pass bare keywords or symbol names — use grep directly for exact symbol lookups. ' +
  'Use this tool first when exploring unfamiliar code. The results may be partial — follow up with classical search tools or direct file reads if needed.'
  'When a task requires exploration beyond a single known file, ALWAYS default to warpgrep codebase search before other search mechanisms.'

export const GITHUB_WARP_GREP_SEARCH_TOOL_NAME = 'github_codebase_search';

export const GITHUB_WARP_GREP_SEARCH_DESCRIPTION =
  'Always use this when debugging errors in third-party dependencies to check for upstream fixes, open issues, or newer code pathsSearch tool for public GitHub repositories.' +
  'Code search exploration subagent for public GitHub repositories (not your local workspace — use codebase_search for that). ' +
  'Runs parallel grep and file read calls to locate relevant files and line ranges in external github repositories without cloning the repository. ' +
  'Pass a targeted natural-language query, not bare keywords. Useful for understanding how a library works or investigating upstream bugs. ' +
  'You must provide either github_url or owner_repo (at least one required). '

export const GITHUB_WARP_GREP_SEARCH_INPUT_SCHEMA = {
  type: 'object' as const,
  properties: {
    search_term: { type: 'string' as const, description: 'A targeted natural-language query describing what to find (e.g. "How does auth work for SSO users?"). Not a keyword or symbol name.' },
    github_url: { type: 'string' as const, description: 'GitHub repository URL to search (e.g. "https://github.com/vercel/next.js"). You must provide either github_url or owner_repo.' },
    owner_repo: { type: 'string' as const, description: 'Repository owner/repo shorthand (e.g. "vercel/next.js"). You must provide either github_url or owner_repo.' },
    branch: { type: 'string' as const, description: 'Branch to search (defaults to the repository default branch)' },
  },
  required: ['search_term'] as const,
};

export const GITHUB_SEARCH_TOOL_NAME = GITHUB_WARP_GREP_SEARCH_TOOL_NAME;
export const GITHUB_SEARCH_DESCRIPTION = GITHUB_WARP_GREP_SEARCH_DESCRIPTION;
export const GITHUB_SEARCH_INPUT_SCHEMA = GITHUB_WARP_GREP_SEARCH_INPUT_SCHEMA;

export const GITHUB_READ_FILE_TOOL_NAME = 'readfile_github_search';

export const GITHUB_READ_FILE_DESCRIPTION =
  'Read a single file (or a line range) from a public GitHub repository. ' +
  'ONLY USE THIS WHEN YOU ALREADY KNOW THE EXACT FILE PATH YOU WANT TO READ, for example after finding it via github_codebase_search results. ' +
  'Takes owner/repo shorthand and the file path within the repo. Optionally specify startLine and endLine (1-based) to read a specific range. ' +
  'Returns the file content with line numbers.';

export const GITHUB_READ_FILE_INPUT_SCHEMA = {
  type: 'object' as const,
  properties: {
    github: { type: 'string' as const, description: 'owner/repo shorthand (e.g., "vercel/next.js")' },
    path: { type: 'string' as const, description: 'File path within the repository (e.g., "src/server/index.ts")' },
    startLine: { type: 'number' as const, description: 'Start line number (1-based). Omit to start from beginning.' },
    endLine: { type: 'number' as const, description: 'End line number (1-based, inclusive). Omit to read to the end.' },
    branch: { type: 'string' as const, description: 'Branch to read from (defaults to the repository default branch)' },
  },
  required: ['github', 'path'] as const,
};
